const hplcMsTicPosJcamp = `
##TITLE=Spectrum
##JCAMP-DX=5.00 $$ chemotion-converter-app (1.8.0)
##DATA TYPE=MASS TIC
##DATA CLASS=XYPOINTS
##ORIGIN=
##OWNER=
##XUNITS=MINUTES
##YUNITS=COUNTS
##SOFTWARE=openlab
##SCAN_MODE=positiv
##TYPE=ms chromatogramm
##FIRSTX=0.009
##LASTX=10.001416666666668
##MINX=0.009
##MAXX=10.001416666666668
##MINY=151.26661858034518
##MAXY=33702.5
##NPOINTS=1200
##FIRSTY=33702.5
##XUNITS=MINUTES
##YUNITS=COUNTS
##XYDATA=(XY..XY)
0.009, 33702.5
0.017366666666666666, 7414.098237720285
0.0257, 11870.477386934672
0.03403333333333333, 6376.395759717315
0.042366666666666664, 7593.559322033898
0.0507, 5743.370582905467
0.059033333333333333, 8225.99247806101
0.06736666666666667, 5530.695443645084
0.0757, 9725.275301520713
0.08403333333333333, 4184.921348314607
0.09236666666666667, 5383.000587199061
0.1007, 9136.290322580644
0.10903333333333333, 7827.885462555067
0.11736666666666666, 5750.0
0.1257, 8930.188679245284
0.13403333333333334, 4397.9013906447535
0.14236666666666667, 4771.366828741221
0.15068333333333334, 7052.065471551052
0.15903333333333333, 5326.061145740576
0.16736666666666666, 8773.66026289181
0.1757, 7082.718524458701
0.18403333333333333, 6037.382501807665
0.19236666666666666, 5293.211267605634
0.2007, 7158.779264214047
0.20903333333333332, 4675.6197221465545
0.21735, 7275.883319638456
0.22568333333333335, 6145.859649122806
0.23401666666666668, 8460.277910876857
0.24235, 5596.1193072482365
0.2506833333333333, 8239.744155271283
0.25903333333333334, 11895.27983816588
0.26736666666666664, 6388.40631730079
0.2757, 6674.773413897281
0.28403333333333336, 6435.985915492958
0.2923666666666667, 6255.446584938704
0.3007, 7296.816087138668
0.3090333333333333, 5386.977806788513
0.3173666666666667, 7229.123817359111
0.3257, 8482.851445663011
0.33403333333333335, 8714.179841897232
0.34236666666666665, 8051.3972055888225
0.3507, 8228.920926168634
0.3590833333333333, 6271.401370906321
0.36741666666666667, 6145.700518902891
0.37575, 5199.468556244464
0.3840833333333334, 9982.209631728045
0.3924166666666667, 9013.032324268856
0.40075, 5543.307839388145
0.40908333333333335, 6321.512539184953
0.41741666666666666, 6089.242424242424
0.42575, 4381.566579634465
0.4341, 3840.0043131334915
0.44243333333333335, 8547.663551401869
0.45075, 4245.08952794357
0.4591, 7442.320966350302
0.4674333333333333, 5412.463674523733
0.47576666666666667, 5892.916528101097
0.4841, 6992.018779342722
0.49243333333333333, 7060.95919225915
0.5007666666666667, 9527.225433526011
0.5091, 3973.2958709992668
0.5174333333333333, 8399.236252545825
0.5257666666666667, 7372.20946256316
0.5341, 11756.835530881333
0.5424333333333333, 6811.16564417178
0.5507666666666666, 8051.737451737452
0.5591, 7958.664772727273
0.5674333333333333, 6548.497156783103
0.5757666666666666, 5015.994108983799
0.5841, 6836.702568351284
0.5924333333333334, 8228.423913043478
0.6007666666666667, 6788.0660177740165
0.6091, 5586.553524804178
0.6174333333333333, 6868.077084206117
0.6257666666666667, 3713.211051776178
0.6341, 5382.691695832007
0.6424333333333333, 5730.414163768574
0.6507666666666668, 6694.525235243798
0.6591, 6428.543987706493
0.6674333333333333, 13378.367975365667
0.6757666666666666, 7436.953754773016
0.6841, 9437.176097303014
0.6924333333333333, 5640.236686390533
0.7007666666666666, 6608.038720538721
0.7091, 5966.620257570484
0.7174333333333334, 4122.790813779331
0.7257666666666667, 7001.397121083827
0.7341, 8403.915662650603
0.7424333333333333, 5910.349330721515
0.7507666666666667, 11589.328859060402
0.7591166666666667, 5985.845347313237
0.7674333333333333, 9228.932584269663
0.7757833333333334, 7659.862385321101
0.7841166666666667, 6948.309178743962
0.7924333333333333, 7559.749638902263
0.8007666666666666, 9296.920289855072
0.8091166666666667, 7146.915803692031
0.8174499999999999, 3343.465520609494
0.8257833333333333, 7471.963048498846
0.8341166666666666, 6885.924453280319
0.8424333333333334, 5143.455205135361
0.8507666666666667, 6074.136321195145
0.8591166666666666, 5993.641464066257
0.8674333333333333, 4886.423841059603
0.8757666666666667, 4458.158995815899
0.8841, 5383.698384201078
0.8924333333333333, 4327.768685215494
0.9007666666666668, 3283.3107756376885
0.9091, 5243.187367735633
0.9174333333333333, 2526.7028592110023
0.9257666666666666, 2331.4238552301767
0.9341, 1519.443725743855
0.9424333333333333, 1555.5292031017984
0.9507666666666666, 1600.5191434133678
0.9591, 1185.036464410735
0.9674333333333334, 1038.6358055009823
0.9757666666666667, 888.8056262617397
0.9841, 904.5024552281917
0.9924333333333333, 734.3955793750876
1.0007666666666666, 683.4263822578162
1.0091, 663.3788495061011
1.0174333333333334, 702.1032790808999
1.0257666666666667, 541.6186575970015
1.0341, 672.4831976524044
1.0424333333333333, 835.755060478894
1.0507666666666666, 952.7305627846454
1.0591, 840.3074374079529
1.0674333333333332, 1062.3145220141084
1.0757666666666668, 1033.5421914357682
1.0841, 1252.014086736309
1.0924333333333334, 1250.209471766849
1.1007666666666667, 1430.5233739837397
1.1091, 1074.8060762766647
1.1174333333333333, 1471.301433194637
1.1257666666666666, 1717.4807922746177
1.1341, 1343.239405854085
1.1424333333333334, 1511.8490801372
1.15075, 1730.906268480189
1.1591, 1583.4842376577888
1.167433333333333, 2309.324423097003
1.1757666666666666, 1655.870189948833
1.1841, 1802.2861647615296
1.1924166666666667, 1681.2621889382947
1.2007666666666668, 2111.4307271526923
1.2091, 1815.8363124667223
1.2174333333333334, 2003.1709880868955
1.2257666666666667, 1868.3683331868901
1.2341, 2265.3357531760435
1.2424166666666667, 2379.3724578733295
1.25075, 2137.55651459104
1.2591, 2880.4
1.2674333333333334, 2699.49273375377
1.2757666666666667, 3028.242742433601
1.2841, 3319.663120567376
1.2924166666666668, 3780.790480237994
1.3007666666666666, 3447.8444483547423
1.3091, 4141.821649976157
1.3174333333333332, 4565.8132162887105
1.3257666666666668, 4246.0004691531785
1.3341, 4970.529801324503
1.3424333333333334, 3804.782799473453
1.3507666666666667, 4525.544344131705
1.3591, 3322.8970125786163
1.3674333333333333, 5729.48350071736
1.3757666666666666, 5231.3551253570295
1.3841, 3463.5390946502057
1.3924333333333334, 2656.0787671232874
1.4007666666666667, 2416.1981461783926
1.4091, 2089.4874476987447
1.417433333333333, 4168.664921465968
1.4257666666666666, 2965.595064133788
1.4341, 2897.1772914684425
1.4424333333333332, 2307.129776584056
1.4507666666666668, 3006.0524091293323
1.4591, 2835.0088042260286
1.4674333333333334, 2632.400799314873
1.4757666666666667, 5605.604431410884
1.4841, 3650.6522219765643
1.4925333333333333, 2750.0785422557333
1.5008666666666666, 3624.798549556809
1.5092, 4593.996569468268
1.5175333333333334, 7751.294744859101
1.5258666666666667, 4213.422498208742
1.5342, 2549.2722905185815
1.5425333333333333, 2513.328313253012
1.5508666666666666, 4168.785714285714
1.5592, 3525.4524226503213
1.5675333333333332, 4417.351710558701
1.5758666666666667, 3861.50099623644
1.5842, 3980.82788671024
1.5925333333333334, 2977.6136935727473
1.6008666666666664, 4139.639222941721
1.6092, 3716.2815126050423
1.6175333333333333, 3168.7017543859647
1.6258666666666666, 2925.281908808629
1.6342, 4951.660815554955
1.6425333333333334, 4406.8536585365855
1.6508666666666667, 3003.772618641174
1.6592, 3484.362859362859
1.6675333333333333, 3500.0198767640627
1.6758666666666666, 5511.24183006536
1.6842, 4316.4727780362955
1.6925333333333332, 3352.089971883786
1.70085, 3545.4988823409876
1.7092, 5288.372093023256
1.7175166666666664, 3556.935483870968
1.72585, 2948.1766820749867
1.7342, 6380.4895608351335
1.7425333333333333, 5220.93553907587
1.7508666666666666, 3236.5398956002987
1.7592, 4509.0
1.7675166666666666, 3485.9163346613545
1.7758666666666667, 7076.525630593978
1.7841833333333332, 5311.054827175209
1.7925166666666668, 4934.051841746248
1.80085, 3978.609013955617
1.8091833333333334, 4607.41910023678
1.8175166666666667, 3150.740674638587
1.82585, 4049.6250852079074
1.8341833333333333, 3883.876357560568
1.8425166666666664, 5453.867318862733
1.85085, 4101.924430884769
1.8591833333333334, 5292.564841498559
1.8675166666666667, 3036.1509309606195
1.87585, 3008.1296839361357
1.8841833333333333, 4872.67984623833
1.8925166666666666, 3194.362342638205
1.90085, 7899.0344827586205
1.9091833333333332, 3592.762526396621
1.9175166666666668, 4517.860824742268
1.92585, 5925.084123585194
1.9342, 3777.436637131671
1.9425166666666667, 3402.3486238532114
1.95085, 3422.899281971667
1.9591833333333333, 4553.457228751025
1.9675166666666664, 2928.5782215882073
1.97585, 3328.29373650108
1.9841833333333334, 3801.0923330585324
1.9925166666666667, 4526.2229947852
2.00085, 4663.299024918743
2.0091833333333335, 4099.008531242795
2.017516666666667, 4719.529882470618
2.02585, 4277.157844539819
2.0341833333333335, 3491.6938423172837
2.0425166666666668, 3620.064076892271
2.05085, 5941.526717557252
2.0592, 3407.5369365999627
2.0675166666666667, 3477.814630550949
2.07585, 3170.8784383318543
2.0841833333333333, 3736.6530612244896
2.0925166666666666, 4976.159828372218
2.10085, 3232.994661615292
2.109183333333333, 4154.566596194503
2.1175166666666665, 4227.50735793525
2.12585, 3601.850780798149
2.1341833333333335, 4414.024818543667
2.142516666666667, 3950.699978462201
2.15085, 4864.464160635069
2.1591833333333335, 4573.393348337085
2.1675166666666668, 4274.161461947721
2.17585, 5382.796317606444
2.184183333333333, 4969.3511156706845
2.1925166666666667, 3207.205654197552
2.20085, 2804.187031606387
2.2091833333333333, 4982.614311547404
2.2175166666666666, 3966.3019693654264
2.22585, 6527.355836849508
2.234183333333333, 3025.195439739414
2.2425166666666665, 6525.639178970112
2.25085, 3403.21109633289
2.2591833333333335, 2934.497227633748
2.267516666666667, 4211.283434479658
2.27585, 4930.632008154944
2.2841833333333335, 5590.014104372356
2.2925166666666668, 3896.8408262454436
2.30085, 4434.7607603233555
2.309183333333333, 4223.694869486949
2.3175166666666667, 4791.55524278677
2.3258666666666667, 4755.499874718115
2.3342, 3152.0580727504785
2.3425333333333334, 2845.7452966714905
2.3508666666666667, 3672.097509645738
2.3592, 2777.6255049047895
2.3675333333333333, 3940.1627953146717
2.3758666666666666, 5556.168359941945
2.3842, 4184.144030322173
2.392533333333333, 4442.21912072575
2.4008666666666665, 6083.717537204552
2.4092, 4775.393883225208
2.4175333333333335, 4258.209902666103
2.425866666666667, 3743.272335844995
2.4342, 3033.159268929504
2.442533333333334, 3284.5352690547575
2.4508666666666667, 4937.082294264339
2.4592, 3195.3259718650734
2.4675333333333334, 3000.462412471925
2.4758666666666667, 4529.100418410042
2.4842, 4661.705069124424
2.4925333333333333, 3799.1462113127
2.5008666666666666, 4909.531392174704
2.5092, 3875.014778325123
2.517533333333333, 4427.633184221228
2.5258666666666665, 3269.9939867708963
2.5342, 3911.9345185706743
2.5425333333333335, 4749.392712550607
2.550866666666667, 4072.290257722537
2.5592, 3595.8855919241355
2.567533333333334, 2579.798098368353
2.5758666666666667, 5739.571647118817
2.5842, 3432.420508139358
2.5925333333333334, 3186.6006328243225
2.6008666666666667, 4602.005850396991
2.6092, 4014.2567692024313
2.6175333333333333, 4577.636570561457
2.6258666666666666, 3337.020150022062
2.6342, 4244.316339398307
2.642533333333333, 4016.3318211276733
2.6508666666666665, 3752.6447574334898
2.6592, 4567.007471490366
2.6675333333333335, 3494.9175211769953
2.675866666666667, 4235.213830755231
2.6842, 4469.884032114184
2.692533333333334, 3488.2162009596386
2.7008666666666667, 4081.596526386106
2.7092, 2772.483690587139
2.7175333333333334, 2896.6803039158385
2.7258666666666667, 4030.7127711629428
2.7342, 3892.1128107074574
2.7425333333333333, 2982.9497416627523
2.7508666666666666, 2948.0360243055557
2.7592, 3315.090206185567
2.767533333333333, 3350.991700661134
2.7758666666666665, 4762.082949308756
2.7842, 4054.5000779909533
2.7925333333333335, 3299.822852081488
2.80085, 2789.1468682505397
2.809183333333333, 3725.5909277223664
2.8175166666666667, 2990.6446457112415
2.82585, 3189.440325281033
2.8341833333333333, 3041.9417475728155
2.8425166666666666, 2293.3922910061738
2.85085, 3255.7177306764816
2.859183333333333, 1767.841991793588
2.8675166666666665, 3036.9741454864156
2.87585, 3634.3561570414045
2.8841833333333335, 2581.1492389444297
2.892516666666667, 2612.8407194511406
2.90085, 3027.987012987013
2.9091833333333335, 2838.3747412008283
2.9175166666666668, 2915.451235114654
2.92585, 2804.6047582501915
2.934183333333333, 3434.987534132732
2.9425166666666667, 3245.773886727194
2.95085, 2466.235540577466
2.9591833333333333, 2149.0196078431372
2.9675166666666666, 2740.8088235294117
2.97585, 2709.6540276078977
2.984183333333333, 2106.4234679857104
2.9925166666666665, 2552.0640054472724
3.00085, 1990.5103823015718
3.0091833333333335, 2677.916070978051
3.017516666666667, 2039.0079135302065
3.02585, 2823.6764161421697
3.0342, 2693.124334943112
3.0425166666666668, 2096.3710214409375
3.05085, 2543.354807921737
3.059183333333333, 2162.005935518683
3.0675166666666667, 2755.433551198257
3.07585, 2017.7933713426478
3.0842, 2104.1185627188997
3.0925166666666666, 2140.5088583988277
3.10085, 2048.1657396412725
3.109183333333333, 1433.732456140351
3.1175166666666665, 1792.1933085501857
3.12585, 1791.4712971078002
3.1342, 2147.340555014606
3.142516666666667, 1526.6786355475763
3.15085, 1954.8934753661786
3.1591833333333335, 1457.4210706932054
3.1675166666666668, 1632.5104245640637
3.17585, 2143.0224564619616
3.1842, 1639.0014342058087
3.1925166666666667, 1649.515924719508
3.20085, 1528.6831103678928
3.2092, 1754.9192928516525
3.2175333333333334, 2102.600633197648
3.2258666666666667, 1361.4716150576805
3.234183333333333, 1823.4344707250873
3.2425166666666665, 1682.7063106796115
3.25085, 1786.1175337186896
3.2591833333333335, 1326.274591299529
3.267516666666667, 1320.5456407255706
3.2758666666666665, 1364.511675607447
3.2842, 1549.7749660326085
3.2925166666666668, 1401.1116894705533
3.30085, 1330.891378818156
3.3092, 1551.432046453233
3.317533333333334, 1393.8098928974068
3.3258666666666667, 1477.2817158503196
3.3342, 1526.234017246506
3.3425333333333334, 1304.641166209818
3.3508666666666667, 1267.4872892694675
3.3592, 1407.8553697413117
3.3675333333333333, 1362.6883923849816
3.3758666666666666, 1142.5145180023228
3.3842, 1237.9270186335405
3.392533333333333, 1202.7973145780052
3.40085, 1290.9480705097665
3.4092, 996.8720289028332
3.4175333333333335, 1140.5784484426388
3.425866666666667, 1216.7900092506939
3.4342, 1132.145799011532
3.4425166666666667, 965.9280013584649
3.45085, 1108.5210720528257
3.4591833333333333, 1240.052888527258
3.4675166666666666, 1260.9413545638035
3.47585, 886.9118835893291
3.484183333333333, 936.6398794575589
3.4925166666666665, 959.8027017419125
3.50085, 1063.4385506163615
3.5091833333333335, 1208.9653507830938
3.517516666666667, 933.8170698743074
3.52585, 998.730274245442
3.5341833333333335, 1068.5993349958437
3.5425166666666668, 1037.2192099147949
3.55085, 915.6309036523929
3.559183333333333, 842.7333333333333
3.5675166666666667, 907.6339341594693
3.57585, 732.830519557722
3.5841833333333333, 998.3752727768684
3.5925166666666666, 942.2664381822798
3.60085, 820.2058995327103
3.609183333333333, 986.2538940809969
3.6175166666666665, 961.9878733899699
3.62585, 849.7539923526766
3.6341833333333335, 789.2521099452555
3.642516666666667, 731.4156514461081
3.65085, 895.0304317868627
3.6591833333333335, 869.6607567973938
3.6675166666666668, 820.0959111559819
3.67585, 761.0647206893213
3.684183333333333, 706.278741138149
3.6925166666666667, 715.817393903168
3.70085, 699.4615238637442
3.7091833333333333, 894.374933018969
3.717633333333333, 682.2990820532034
3.725966666666667, 698.249586244943
3.7343, 657.2285143237842
3.7426333333333335, 669.9495496275767
3.7509666666666663, 720.8588957055215
3.7593, 654.5955574182733
3.7676333333333334, 676.4468139994841
3.7759666666666667, 718.5566688840845
3.7843, 798.8341062210167
3.7926333333333333, 763.0925681618295
3.8009666666666666, 684.557197204282
3.8093, 687.5294394724447
3.817633333333333, 938.1129716211808
3.8259666666666665, 850.8109564876519
3.8343, 831.7872760238909
3.842633333333333, 722.128564282141
3.850966666666667, 749.4727891156464
3.8593, 688.132999443517
3.8676333333333335, 976.5706643443642
3.8759666666666663, 884.5354107648725
3.8843, 882.6383012481489
3.8926333333333334, 1008.8071732066983
3.9009666666666667, 1139.9244332493704
3.9093, 1395.5554505951256
3.9176333333333333, 1484.0599798387098
3.9259666666666666, 1407.8138163437236
3.9343, 1330.109381158849
3.942633333333333, 1545.380368842514
3.9509666666666665, 2012.87835110983
3.9593, 1559.0888012984
3.967633333333333, 1947.9421352893235
3.975966666666667, 2473.983858420848
3.9843, 2228.6798046738754
3.9926333333333335, 2286.665154264973
4.000966666666667, 1998.362429125634
4.0093, 2289.1369047619046
4.017633333333333, 2620.0357873210637
4.025966666666666, 2477.2018348623856
4.0343, 2415.467053538001
4.0426166666666665, 2953.1844316674037
4.05095, 2785.642464013548
4.059283333333333, 2161.4296767537826
4.067616666666667, 1423.0644486294204
4.07595, 729.2473474801061
4.0843, 624.809619238477
4.092616666666666, 497.05105633802816
4.10095, 477.86620082815733
4.109283333333333, 525.1277901785714
4.117616666666667, 393.96713954834973
4.125966666666667, 543.9140751211631
4.1343, 479.93895186118107
4.142633333333333, 401.6845511140236
4.150966666666666, 434.098715651135
4.1593, 495.96269889428265
4.167633333333334, 482.78672089825847
4.175966666666667, 430.9013568813267
4.1843, 532.7977556745728
4.192633333333333, 454.73052384150435
4.20095, 503.7229041301969
4.2093, 476.17207708225556
4.217633333333334, 395.58554657428795
4.225966666666666, 385.8101159311892
4.2343, 416.6246244775339
4.242616666666667, 417.9334064821067
4.25095, 522.5370497748875
4.2593, 411.67444135662436
4.267616666666667, 386.94666536661464
4.275966666666666, 474.7919138976793
4.2843, 374.7331776253548
4.292633333333334, 544.4637252535007
4.300966666666667, 465.9566906747536
4.3092999999999995, 526.6065933653557
4.317633333333333, 524.3937919719169
4.32595, 385.5974602203183
4.3343, 417.1003766544635
4.342616666666666, 384.6838662790698
4.35095, 553.899346058678
4.3593, 392.51885501527494
4.367616666666667, 482.1391843971631
4.37595, 560.7677157714995
4.3843, 510.75035561877667
4.392616666666667, 561.8458601286173
4.40095, 421.39370375445327
4.409283333333334, 496.8705811651584
4.4176166666666665, 423.9722662713734
4.42595, 525.8357558139535
4.4342999999999995, 407.431204569055
4.442633333333333, 672.6612971778306
4.450966666666667, 587.6025906365973
4.4593, 547.866506153023
4.467633333333334, 571.4136255772191
4.475966666666666, 535.892229632817
4.4843166666666665, 423.4705250990753
4.492633333333333, 609.1502383015597
4.500966666666667, 413.953313253012
4.509316666666667, 466.9802621969033
4.517633333333333, 452.3198779054584
4.525966666666666, 452.77179276315786
4.5343, 471.0535198442603
4.542633333333334, 488.39311180832857
4.550966666666667, 452.2235402781802
4.5592999999999995, 495.58414464534076
4.567633333333333, 489.2632532689028
4.575966666666667, 380.02528859608213
4.5843, 487.0061707115279
4.592633333333334, 462.8439016557237
4.600966666666666, 608.9080035440047
4.6093166666666665, 448.52122109419065
4.617633333333333, 430.6738468382152
4.625966666666667, 426.46102308294206
4.6343, 597.8141739498168
4.642633333333333, 448.31686297483964
4.65095, 403.5041272075762
4.6593, 420.64921222046536
4.667633333333334, 427.7215453938585
4.675966666666667, 445.7254623044097
4.6842999999999995, 410.8667679028133
4.692633333333333, 405.8069414956358
4.70095, 589.593962585034
4.7093, 444.5233506066734
4.717616666666666, 443.3758431703204
4.72595, 461.91944847605225
4.734283333333333, 424.68849567592173
4.742616666666667, 395.56205830388694
4.750966666666667, 419.8283333333333
4.7593, 556.6513455901945
4.767633333333333, 402.8743099600658
4.775966666666666, 423.48872950819674
4.7843, 383.4547967809171
4.792633333333334, 515.1665700054585
4.800966666666667, 402.8757385524372
4.8092999999999995, 489.51906242453515
4.817633333333333, 457.8107475325258
4.825966666666667, 502.7687283843874
4.8343, 394.6420495658466
4.842633333333334, 422.87528262273906
4.850966666666666, 540.2691100443132
4.8593, 377.8285200649501
4.867633333333333, 410.208817592366
4.875966666666667, 472.3129646840149
4.8843, 403.69844799701417
4.892633333333333, 397.0066823899371
4.900966666666666, 477.209996538994
4.9093, 457.1881057878704
4.917633333333334, 533.7760534662438
4.925966666666667, 461.85359275962946
4.934316666666667, 506.8001089324619
4.942633333333333, 448.95985179786203
4.950966666666667, 451.4848673048958
4.959316666666667, 495.8176865304112
4.967633333333334, 515.3577302631579
4.975966666666666, 451.71648232677904
4.9843, 497.5833168512658
4.992633333333333, 511.2187821006677
5.000966666666667, 414.02963820731094
5.0093, 399.97395194900713
5.017633333333333, 603.259330223259
5.025966666666666, 511.66558485925117
5.0343, 490.96719457013575
5.042633333333334, 664.1159148335315
5.050966666666667, 440.2304790026247
5.0592999999999995, 436.15553317859093
5.06765, 511.5389608141789
5.075983333333332, 510.80101412649043
5.084316666666667, 527.6722630602341
5.09265, 425.4855510752688
5.100983333333334, 434.26725561426684
5.1093166666666665, 542.7764040974921
5.11765, 548.4958189778927
5.125983333333333, 587.5223715609209
5.134316666666667, 680.4538182593857
5.14265, 444.6395547945205
5.1509833333333335, 501.889764520012
5.159316666666666, 504.6075200431699
5.16765, 613.4100322942993
5.175983333333333, 561.9596581010453
5.184316666666667, 487.8266953930412
5.19265, 640.8789378029079
5.200983333333332, 486.0070190242406
5.209316666666667, 534.3654010238907
5.21765, 485.08234797297297
5.225983333333334, 478.57129086983343
5.234333333333334, 600.5157969323108
5.242666666666667, 545.529
5.251, 593.6587199312715
5.259333333333333, 565.705074875208
5.267666666666667, 612.7557544757034
5.276, 600.4987407211029
5.2843333333333335, 636.8731066980814
5.292666666666666, 585.9660336011686
5.301, 639.0338971643934
5.30935, 756.7367112138264
5.317683333333333, 686.9718567251462
5.326016666666667, 600.7437323446328
5.33435, 560.8973857232311
5.342683333333334, 559.7634366246499
5.351016666666666, 717.7182174670797
5.35935, 676.7703355236957
5.367683333333333, 597.1514595272206
5.376016666666667, 655.942102906051
5.384366666666667, 588.1437794579732
5.392683333333333, 749.2272484459984
5.401033333333333, 679.5049307036247
5.409366666666667, 737.5457173194903
5.4177, 716.4036716171618
5.426033333333334, 661.4189973747981
5.434366666666667, 786.7201782449725
5.4427, 795.1869870678936
5.451033333333333, 728.20374475035
5.459366666666667, 781.8027257709251
5.4677, 765.9766922757475
5.47605, 709.1360249205961
5.484383333333333, 671.3385025062656
5.4927, 776.2854914196569
5.501033333333333, 869.9621423695153
5.509383333333333, 778.231118266979
5.5177, 760.3237680288462
5.526033333333333, 913.6662855276054
5.534383333333333, 721.4186074721009
5.542716666666666, 905.4245430645968
5.55105, 971.185782758388
5.5594, 817.7206551410374
5.567733333333333, 955.4005246891396
5.576066666666667, 979.7021129199861
5.5844, 947.06444809837
5.592733333333333, 992.2116374871266
5.60105, 784.0891117297228
5.6094, 854.6753817256423
5.6177166666666665, 766.4157265890344
5.626066666666666, 920.753596994826
5.6344, 863.5195501366408
5.642716666666667, 853.1198435494714
5.651066666666667, 976.4540420428895
5.6594, 871.8218734943905
5.6677333333333335, 896.3865546218487
5.676066666666666, 995.4476282384381
5.6844, 885.5387475271165
5.692733333333333, 852.885660890248
5.701066666666667, 877.9540636042402
5.7094, 877.0525481150436
5.717733333333333, 1091.6422403549077
5.726066666666667, 775.3934624697337
5.7344, 1066.8443113772455
5.742733333333334, 1022.6023788015658
5.751066666666666, 1050.6065293495074
5.7594, 1025.9231794342704
5.767733333333333, 1165.695764909248
5.776066666666667, 983.8718178978604
5.784416666666667, 967.643600616808
5.79275, 1071.5395072917524
5.801066666666666, 1163.4940175809863
5.8094166666666665, 1053.7129199779683
5.81775, 1189.5273620627481
5.826083333333333, 1047.418337366056
5.834416666666667, 1028.9554323355292
5.84275, 1092.611740513696
5.851083333333333, 976.4151687164933
5.8594333333333335, 1003.2432869621482
5.86775, 939.5321942848616
5.8761, 1073.0934276058342
5.884433333333333, 1194.2025664527955
5.89275, 1129.05853761623
5.9011, 1319.1418619379353
5.909433333333333, 1184.041849215042
5.917766666666667, 1299.8126767200754
5.9261, 1147.8141543000954
5.934433333333334, 1236.6377421334034
5.9427666666666665, 1246.491248706126
5.9511, 1329.9979432332373
5.959433333333333, 1197.0319840983013
5.967766666666667, 1343.183466279913
5.9761, 1162.2876213592233
5.9844333333333335, 1220.5837664053554
5.992766666666666, 1142.8311450518042
6.001116666666666, 1073.0032076984762
6.0094666666666665, 1022.0496517090556
6.0178, 1046.1992898538895
6.026133333333333, 1163.9409120704186
6.034466666666666, 1254.6508175755914
6.0428, 1159.5671061823264
6.0511333333333335, 1280.1308889452762
6.059466666666666, 1323.4489292323963
6.0678, 1356.6100652729165
6.076133333333333, 1450.1184117706339
6.084466666666667, 1159.0877343186733
6.0928, 1330.5708717558703
6.101133333333333, 1317.7127409496943
6.109466666666667, 1394.3207899015015
6.1178, 1427.6261018609207
6.126133333333334, 1478.2311062431545
6.1344666666666665, 1414.39258070606
6.1428, 1339.859413202934
6.151133333333333, 1576.7213728215545
6.159466666666666, 1427.0718034351146
6.1678, 1552.8871866295265
6.1761333333333335, 1644.9561919322593
6.184466666666666, 1443.9990732159406
6.1928, 1427.2623058207
6.201133333333333, 1568.2440911943108
6.209466666666667, 1465.9673124598291
6.2178, 1607.1926959619952
6.226133333333333, 1527.371706645694
6.234466666666667, 1281.4027350703998
6.2428, 1621.2538105750027
6.251133333333334, 1515.530193585669
6.2594666666666665, 1503.7630000936942
6.2678, 1555.491177873152
6.276133333333333, 1791.4914207993304
6.284466666666666, 1758.7187812187813
6.2928, 1654.4288039835296
6.3011333333333335, 2070.8897855796417
6.309466666666666, 1680.8582404197507
6.3178, 1793.1454720616568
6.326133333333333, 1757.1368501529053
6.334466666666667, 1593.1972111553785
6.3428, 1632.873790677221
6.351133333333333, 2003.3413560016386
6.359466666666667, 1710.9865255052935
6.3678, 2255.2960859295918
6.376133333333334, 1918.303832650673
6.3844666666666665, 1948.7615178836818
6.3928, 1888.320750121773
6.401133333333333, 1924.2284244618024
6.409466666666666, 2009.1919602070857
6.4178, 2083.0826586040794
6.4261333333333335, 2116.6553918620966
6.434466666666666, 2136.7178896786463
6.4428, 1919.3846591447805
6.451133333333333, 2094.176978267651
6.459466666666667, 1967.500245290424
6.4678, 2048.8483398145377
6.476133333333333, 2227.053435114504
6.484466666666667, 2177.507949915532
6.4928, 3056.3184600515465
6.501133333333334, 2652.8134646813146
6.5094666666666665, 2489.0412471294826
6.5178, 2646.610346266166
6.526133333333333, 2188.319134993447
6.534466666666666, 2040.6127861529872
6.5428, 2325.9512732615085
6.5511333333333335, 2330.789881130756
6.5594833333333336, 1851.042301995295
6.567816666666666, 2330.4466532460997
6.57615, 2161.6324571766095
6.584483333333333, 1998.5478184222125
6.592816666666667, 1833.698593073593
6.60115, 1927.345313921747
6.609483333333333, 1584.7922053934246
6.617816666666666, 1055.1774522483088
6.62615, 762.3315170633782
6.634483333333334, 896.4525636227545
6.642816666666667, 1043.9144407763106
6.65115, 2108.559948979592
6.659483333333333, 1742.9554446929296
6.667816666666667, 1682.5810082994878
6.676149999999999, 1744.1340288215013
6.6844833333333336, 1668.1135556801196
6.6928, 1635.304898367211
6.70115, 1636.0467230251795
6.709483333333333, 1577.9094119579502
6.717816666666667, 1468.486082555749
6.72615, 1409.552495697074
6.734483333333333, 1457.2801767973087
6.742816666666666, 1603.6389172625127
6.751133333333334, 1669.9528827406925
6.759483333333334, 1591.9321388865133
6.767816666666667, 1646.99914483402
6.77615, 1165.8646555459272
6.784483333333333, 585.2501132018515
6.792816666666667, 526.6465053763441
6.801149999999999, 571.7563023790213
6.8094833333333336, 397.79565520446096
6.817816666666666, 467.7442211425206
6.82615, 515.8585688251443
6.834483333333333, 471.5278365791702
6.842816666666667, 349.91717373450797
6.85115, 328.56770243220785
6.859483333333333, 287.37534768316584
6.867816666666666, 308.67468533551795
6.87615, 281.5978236872495
6.8845, 281.03496388706503
6.892816666666667, 346.261504202178
6.90115, 269.0863501048865
6.909483333333333, 267.044530839464
6.917833333333333, 306.30880743982493
6.926166666666668, 344.47763826185104
6.9345, 212.53847263003357
6.942833333333334, 229.2996879865707
6.9511666666666665, 205.56612696615824
6.9595, 192.3791678100988
6.967833333333333, 291.4132355062013
6.976166666666667, 196.86966607350377
6.9845, 288.1340455206986
6.9928333333333335, 276.65925202546293
7.001166666666666, 176.15788051060267
7.009516666666666, 165.75209312039908
7.01785, 175.77163499630257
7.026183333333333, 173.46960443972924
7.034516666666667, 259.8710163985149
7.04285, 172.34091654311132
7.051183333333333, 259.72429778396764
7.059533333333333, 163.69418532338307
7.067866666666666, 253.44277990044867
7.0762, 263.3970403800166
7.084533333333334, 343.81432676128964
7.09285, 163.68619612492628
7.101183333333333, 251.74477196425195
7.109533333333333, 242.73030794114706
7.11785, 151.26661858034518
7.1262, 220.71463287936143
7.134533333333334, 238.83491555507743
7.14285, 160.04984951091046
7.1512, 162.69337289346976
7.159533333333333, 222.4611120420018
7.167866666666667, 266.07744107744105
7.1763, 447.437333672511
7.184633333333333, 493.87388973136916
7.192966666666667, 402.1007053702538
7.2013, 604.3477895726955
7.209633333333334, 751.373174359899
7.217966666666666, 764.5270775209246
7.2263, 788.5870162708883
7.234633333333333, 783.5989882662835
7.242966666666667, 822.4607564874884
7.2513, 959.1719378953422
7.25965, 1037.1345618405628
7.2679833333333335, 839.4523650291828
7.276316666666665, 969.7123665173958
7.28465, 907.6528065045289
7.292966666666667, 980.8003219484883
7.3013, 979.8579728857328
7.309633333333333, 773.6362986270022
7.317966666666667, 691.5172373900972
7.3263, 935.9460522714833
7.334633333333334, 766.0289303028395
7.342966666666666, 999.2349492349492
7.3513, 845.4303690731011
7.359633333333333, 885.6550991501416
7.3679499999999996, 950.7743825868564
7.3763, 768.1655365566038
7.384616666666667, 726.0132854688267
7.39295, 750.4141753861485
7.4013, 850.3141877856253
7.409633333333334, 817.098948462432
7.417966666666667, 827.7052121364724
7.4263, 922.7913220384205
7.434633333333333, 894.6017226413835
7.442966666666667, 938.3931419457736
7.4513, 835.0977768132716
7.459633333333334, 674.2025168276266
7.467966666666666, 671.4547413793102
7.4763, 543.4709667402705
7.484633333333333, 575.9690782003973
7.492966666666667, 365.0222828647715
7.5013, 408.8025241837969
7.5096333333333325, 350.51959703854413
7.517966666666666, 551.0197422936692
7.5263, 473.1980301850891
7.534633333333334, 544.4582769290273
7.542966666666667, 485.2422171438427
7.5513, 450.61450146401603
7.559633333333333, 419.13129796759523
7.567966666666667, 332.171630859375
7.5763, 355.10558527885865
7.584633333333334, 489.49119232139674
7.592966666666666, 456.81435873605943
7.6013, 334.1387449575741
7.609633333333333, 418.6292064574807
7.617966666666667, 601.869006102877
7.6263, 763.1653780764248
7.6346333333333325, 1222.158962370862
7.642966666666666, 1157.9897637158117
7.6513, 979.5449705402144
7.659633333333334, 1048.221888542538
7.667966666666667, 993.3074886535552
7.6763, 915.4975895316804
7.684633333333333, 1147.0861784789263
7.692966666666667, 1141.5068519369163
7.7013, 1026.6975533386733
7.709633333333334, 916.0933462532299
7.717983333333334, 978.4128462944733
7.7263166666666665, 1119.6633092356428
7.73465, 1042.6653883029721
7.742983333333333, 1358.5167441419221
7.751316666666667, 1051.3178751422533
7.75965, 1218.3331233198924
7.7679833333333335, 1198.734775304494
7.776333333333334, 1552.9493260109837
7.78465, 995.7444286391656
7.792983333333333, 1353.9420643104904
7.801316666666667, 1088.7099479953029
7.80965, 1281.5463268496005
7.817983333333333, 1252.827598828697
7.826316666666667, 1275.269871236325
7.83465, 1193.4504685408301
7.842983333333334, 1063.3512706882518
7.8513166666666665, 1209.4519195444527
7.85965, 1094.9889527176315
7.867983333333333, 1200.858316018601
7.876316666666667, 1307.0566244404229
7.884666666666667, 1253.1204462659382
7.893, 864.3511374028349
7.901316666666665, 1300.6328497712004
7.90965, 1113.9389502140123
7.917983333333333, 1219.5094532447624
7.926333333333333, 830.6050059241705
7.934666666666667, 1086.8493536913334
7.943, 1002.9441384413022
7.951333333333333, 1117.2185875604948
7.959666666666666, 969.8322868473233
7.968, 923.7446213425128
7.976333333333334, 1021.4544983147523
7.984666666666667, 1069.8316357889191
7.993, 1047.6768857711959
8.001333333333333, 1045.9847999267467
8.009666666666666, 866.6757171747435
8.018, 1159.879207252387
8.026333333333334, 919.4775678866588
8.034666666666666, 928.3694963573014
8.043, 1038.0271333885667
8.051333333333334, 1028.3307176789956
8.059666666666667, 1035.7067462138596
8.068, 1028.4920917007287
8.076333333333332, 1069.7362508986341
8.084666666666667, 861.868838889307
8.093, 890.5112389313555
8.101333333333333, 1005.2181142410016
8.109666666666667, 952.5857833101302
8.118, 901.7693014705883
8.12635, 948.8103828041926
8.134666666666666, 1031.0377948534667
8.143, 915.6067112563654
8.151333333333334, 1025.4060181368507
8.159683333333334, 972.2638449061559
8.168, 1075.7232953126302
8.176333333333334, 873.0704509759928
8.184666666666667, 984.1553704023485
8.193016666666667, 945.6154152199074
8.20135, 917.059301380991
8.209683333333333, 998.1832414244323
8.218016666666667, 889.690638160026
8.22635, 929.4967348097672
8.234683333333333, 812.879521405353
8.243016666666668, 948.952143253308
8.25135, 1098.4522911954427
8.2597, 891.6168941979522
8.268033333333333, 950.1829409942698
8.276366666666666, 1071.8250716919295
8.2847, 1096.7068075694274
8.293016666666666, 1051.8512964842669
8.301366666666667, 871.3431799414458
8.309716666666667, 1163.8373903198415
8.318033333333334, 1031.0953184492905
8.326366666666667, 1033.983840629275
8.3347, 1019.2839796162116
8.343033333333333, 1095.8767140680548
8.351366666666667, 1421.249226644669
8.359716666666667, 1166.5795968737145
8.36805, 1680.0805933383313
8.376383333333333, 1493.4093494673698
8.384716666666666, 1530.1882750277246
8.393033333333333, 1357.1327215968215
8.401366666666666, 1372.8647034164744
8.4097, 1380.1382179280731
8.418033333333334, 1501.9436295054486
8.426366666666667, 1504.4804549469966
8.4347, 1525.4053823395539
8.443033333333334, 1591.5188601158802
8.451366666666667, 1306.8551427032849
8.4597, 1260.1075705297342
8.468033333333333, 1215.3298274277545
8.476366666666667, 1378.7812705727454
8.4847, 1236.0527879568187
8.493033333333333, 1434.5318308550186
8.501366666666666, 1262.5355774493705
8.5097, 1391.9513403567332
8.518033333333333, 1391.214481852913
8.526366666666666, 1266.6195965417867
8.534716666666666, 1432.6400200476132
8.543033333333334, 1368.0542844068184
8.551366666666667, 1133.498062015504
8.559716666666667, 1316.0633618640038
8.56805, 1129.0458681620992
8.576383333333334, 1300.635691842197
8.5847, 1149.7200226244345
8.593033333333333, 1378.563091288856
8.601366666666667, 1256.754066659083
8.6097, 1408.507212776919
8.618033333333333, 1220.711590296496
8.626366666666666, 1177.6003458394466
8.6347, 1146.2342528236316
8.643033333333333, 1316.379052518244
8.651366666666666, 1087.922913789702
8.659700000000003, 1012.4848653011804
8.668033333333334, 1286.5509505254458
8.676383333333336, 1338.8848039215686
8.6847, 978.0366452777221
8.693033333333334, 1244.5426759597806
8.701366666666667, 1145.7127071823204
8.7097, 1048.3712354025815
8.718033333333333, 1330.8430598466643
8.726366666666667, 1165.5172858617132
8.7347, 1333.0495853288169
8.743033333333333, 1264.010477608765
8.751366666666666, 1233.6342465753426
8.7597, 1384.6171507289635
8.768033333333333, 1272.2222222222224
8.776366666666666, 1551.0889207377866
8.784700000000003, 1434.1820528092119
8.793033333333334, 1645.3743919388464
8.801366666666667, 1751.7022296811315
8.8097, 1489.3696814313769
8.818033333333334, 1783.7419181034484
8.826366666666667, 1690.6690534795257
8.8347, 2000.5259401762444
8.843033333333333, 1722.4363126079447
8.851366666666667, 1584.4953754080523
8.8597, 1482.2812590939955
8.868033333333333, 1827.2683183682518
8.876366666666666, 2069.2737037453603
8.8847, 1774.515972894482
8.893033333333333, 1931.4983713355048
8.901366666666666, 1824.0794367693943
8.909716666666666, 1929.5564655669627
8.91805, 1464.2532886772658
8.926383333333336, 1450.063348046428
8.934716666666667, 1831.3840858149215
8.943033333333334, 1266.9847126112131
8.951366666666667, 1696.8022506657503
8.959716666666667, 1714.9101849393858
8.968033333333333, 1745.7245372440311
8.976366666666667, 1595.6937340153454
8.9847, 1492.9788233284944
8.993033333333333, 1503.3517587939698
9.001366666666666, 1376.2744495889635
9.0097, 1600.1037725935269
9.018033333333333, 1471.589432654829
9.026366666666666, 1421.7349741490737
9.034700000000003, 1605.3474842767296
9.043033333333334, 1310.7524875621891
9.051366666666667, 1279.0517056999252
9.0597, 1456.0958619871947
9.068033333333334, 1733.8988095238096
9.076366666666667, 1332.8531746031745
9.0847, 1322.7202493190864
9.093016666666667, 1468.4112066933774
9.101366666666667, 1332.325758399478
9.1097, 1352.552066472429
9.118033333333333, 1398.682068268583
9.126366666666666, 1368.2264079558968
9.1347, 1539.2700363727579
9.143033333333333, 1307.577746884976
9.151366666666666, 1279.0521978021977
9.159700000000003, 1201.0611581642702
9.168033333333334, 1166.000694123091
9.176366666666667, 1196.1288746160292
9.1847, 1137.0696529080676
9.193033333333334, 1199.0543362144313
9.201366666666667, 1250.8161554393923
9.2097, 1062.6405771934176
9.218033333333333, 1144.119425365193
9.226366666666667, 1226.8521341463415
9.2347, 1320.1598015460945
9.243033333333333, 1510.4720529114252
9.251366666666666, 1759.1140459485487
9.2597, 1624.2273397693752
9.268033333333333, 1497.3156148259454
9.276366666666666, 1819.875740994072
9.284700000000003, 2116.6888412017165
9.293033333333334, 1861.367010470386
9.301366666666667, 1590.2406150159745
9.3097, 1758.8742281681857
9.318033333333334, 2052.7434984263705
9.326366666666667, 1873.360052948963
9.3347, 1750.9762050030506
9.343033333333333, 2005.3886997405968
9.351366666666667, 2154.6794758278734
9.3597, 2286.6227229146693
9.368033333333333, 1941.0487742156693
9.376366666666666, 2074.7117973746213
9.3847, 1888.3690590879899
9.393033333333333, 2113.4170762789004
9.401366666666666, 2317.887414777962
9.409716666666666, 2386.218009032744
9.418033333333334, 2353.1021712662337
9.426383333333336, 1991.8921615581098
9.434716666666667, 1968.2623970279437
9.44305, 2245.9470046082947
9.451366666666667, 2191.599982791258
9.459716666666667, 2635.229064039409
9.46805, 1955.9827637224441
9.476383333333333, 2457.3616600790515
9.484716666666667, 2675.285388127854
9.49305, 2478.2701096892138
9.501383333333333, 2587.0906007751937
9.509716666666666, 2524.3502290380407
9.51805, 2490.16328619278
9.526383333333333, 2552.3980099502487
9.534716666666666, 2558.0917394757744
9.54305, 2131.330361734956
9.551383333333336, 2418.7488160636485
9.559716666666667, 2372.7109836946784
9.56805, 2536.211003175789
9.576383333333334, 2637.8049980322708
9.584716666666667, 2322.646927871772
9.59305, 2593.6490384615386
9.601383333333333, 2558.438757906843
9.609716666666667, 2423.9585342333653
9.618066666666667, 2295.4483810815395
9.6264, 2835.164620535714
9.634733333333333, 2334.4424460431655
9.643066666666666, 2498.1813476378693
9.6514, 2205.741965973535
9.659733333333334, 2298.934790663209
9.668066666666666, 2124.224627988631
9.6764, 2488.427536231884
9.684733333333334, 2437.956029185868
9.693066666666668, 2361.3653273809523
9.7014, 2351.8528660094926
9.709733333333334, 2299.7649260544094
9.718066666666667, 2379.2000891265598
9.7264, 2350.0235671191554
9.734733333333333, 2480.5383663366338
9.743066666666667, 2567.848233885452
9.751383333333333, 2319.6067888535626
9.759733333333333, 2474.2480823576907
9.76805, 2410.914555800294
9.7764, 2434.0038921071687
9.784733333333334, 2795.351387188902
9.793066666666666, 2708.3894529631166
9.8014, 2652.509023460999
9.809733333333334, 2390.611626248217
9.818066666666668, 2979.2310863739435
9.8264, 2862.8342391304345
9.834733333333334, 2628.259575312562
9.843066666666667, 2381.8071663493165
9.8514, 2689.365150608418
9.859733333333333, 2320.9127337488867
9.868066666666667, 2780.3489137590523
9.8764, 2676.768221003135
9.884733333333333, 2719.856935014549
9.893066666666666, 2792.05220713073
9.901383333333333, 2938.0195599022004
9.909733333333334, 2753.1940466448445
9.918066666666666, 3277.16814159292
9.9264, 3414.004297994269
9.934733333333334, 2744.6439757778244
9.943066666666668, 2873.305591818973
9.951416666666667, 3357.435537401072
9.959750000000001, 3846.6666666666665
9.968083333333333, 3327.768087855297
9.976416666666667, 4361.162331247942
9.98475, 4003.1831395348836
9.993083333333333, 5081.540028338646
10.001416666666668, 6529.719020172911
##END=$$ End of the data block

`;

export default hplcMsTicPosJcamp;
